
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investment-dao",
      function () {
        return require("private-next-pages/investment-dao.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investment-dao"])
      });
    }
  